<template>
  <div class="studioData" v-loading="loading">
    <div class="header">
      <div class="header_left">
        <el-radio-group v-model="teamId" @input="teamChange">
          <el-radio-button
            v-for="team in teamList"
            :key="team.id"
            class="header_left_radio"
            :label="team.id">
            {{ team.name }}
          </el-radio-button>
        </el-radio-group>
      </div>
      <div class="header_right">
        <DateSelect v-model="date" @change="dateChange"></DateSelect>
      </div>
    </div>

    <div class="card summary">
      <div class="card_header">
        <div class="card_header_left">
          <div class="card_header_title">数据汇总展示</div>
          <div class="card_header_date">{{ date | dateFilter }}</div>
        </div>
      </div>
      <div class="summary_list">
        <div class="summary_item outpatient">
          <div class="summary_title">门诊数据汇总</div>
          <div class="summary_info">
            <div class="summary_info_item">
              <div class="summary_info_left">
                <div class="summary_info_label">挂号数(个)</div>
                <div class="summary_info_value">{{ summaryMap.registerCount }}</div>
              </div>
              <div class="summary_info_right">
                <div class="summary_info_label">挂号金额(元)</div>
                <div class="summary_info_value">{{ summaryMap.registerAmount }}</div>
              </div>
            </div>
            <div class="summary_info_line"></div>
            <div class="summary_info_item">
              <div class="summary_info_left">
                <div class="summary_info_label">门诊人数(人)</div>
                <div class="summary_info_value">{{ summaryMap.orderCount }}</div>
              </div>
              <div class="summary_info_right">
                <div class="summary_info_label">销售额(元)</div>
                <div class="summary_info_value">{{ summaryMap.orderAmount }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="summary_item physio">
          <div class="summary_title">理疗数据</div>
          <div class="summary_info">
            <div class="summary_info_item">
              <div class="summary_info_left">
                <div class="summary_info_label">开单人数(人)</div>
                <div class="summary_info_value">{{ summaryMap.physioOrderCount }}</div>
              </div>
              <div class="summary_info_right">
                <div class="summary_info_label">开单金额(元)</div>
                <div class="summary_info_value">{{ summaryMap.physioOrderAmount }}</div>
              </div>
            </div>
            <div class="summary_info_line"></div>
            <div class="summary_info_item">
              <div class="summary_info_left">
                <div class="summary_info_label">执行人数(人)</div>
                <div class="summary_info_value">{{ summaryMap.physioExecuteCount }}</div>
              </div>
              <div class="summary_info_right">
                <div class="summary_info_label">执行金额(元)</div>
                <div class="summary_info_value">{{ summaryMap.physioExecuteAmount }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="member">
        <div class="member_title">成员数据展示</div>
        <div class="member_tabel_content">
          <el-table class="member_table" :data="memberMap.list" stripe border :header-cell-class-name="memberTabelHeaderCell">
            <el-table-column prop="name" label="成员" min-width="220">
              <template slot-scope="scope">
                <div class="tabel_user">
                  <div class="tabel_user_portrait">
                    <img class="tabel_user_portrait_img" :src="scope.row.doctorImgAddr" />
                  </div>
                  <div class="tabel_user_info">
                    <div class="tabel_user_name">{{ scope.row.doctorName }}<span v-if="scope.row.curDoctor">(我)</span></div>
                    <div class="tabel_user_type">
                      <div v-for="(type, typeIndex) in scope.row.doctorType" :key="typeIndex" class="tabel_user_type_tag">{{ type | doctorTypeFilter }}</div>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="registerCount" label="挂号数(个)" min-width="120"></el-table-column>
            <el-table-column prop="registerAmount" label="挂号金额(元)" align="right" min-width="120"></el-table-column>
            <el-table-column prop="orderCount" label="门诊人数(人)" min-width="120"></el-table-column>
            <el-table-column prop="orderAmount" label="销售额(元)" align="right" min-width="120"></el-table-column>

            <el-table-column prop="physioOrderCount" label="理疗开单人数(人)" min-width="140"></el-table-column>
            <el-table-column prop="physioOrderAmount" label="理疗开单金额(元)" align="right" min-width="140"></el-table-column>
            <el-table-column prop="physioExecuteCount" label="执行人数(人)" min-width="120"></el-table-column>
            <el-table-column prop="physioExecuteAmount" label="执行金额(元)" align="right" min-width="120"></el-table-column>
            <el-table-column prop="allotPhysioExecuteCount" label="我分配执行数(人)" min-width="140"></el-table-column>
            <el-table-column prop="allotPhysioExecuteAmount" label="我分配执行金额(元)" align="right" min-width="150"></el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    getStudioStatistics,
    getStudioMember
  } from "@/api/doctorDataAnalysis"

  import DateSelect from './components/DateSelect.vue'

  export default {
    name: 'studioData',
    components: { DateSelect },
    filters: {
      dateFilter (value) {
        if (Array.isArray(value) && value.length === 2) {
          if (value[0] === value[1]) {
            const today = new Date().Format('yyyy-MM-dd')
            if (value[0] === today) {
              return `今天${new Date(today).Format('MM.dd')}`
            }

            let tomorrowDay = new Date()
            tomorrowDay.setDate(tomorrowDay.getDate() + 1)
            tomorrowDay = tomorrowDay.Format('yyyy-MM-dd')
            if (value[0] === tomorrowDay) {
              return `明天${new Date(tomorrowDay).Format('MM.dd')}`
            }

            let afterTomorrow = new Date()
            afterTomorrow.setDate(afterTomorrow.getDate() + 2)
            afterTomorrow = afterTomorrow.Format('yyyy-MM-dd')
            if (value[0] === afterTomorrow) {
              return `后天${new Date(afterTomorrow).Format('MM.dd')}`
            }

            let yesterdayDay = new Date()
            yesterdayDay.setDate(yesterdayDay.getDate() - 1)
            yesterdayDay = yesterdayDay.Format('yyyy-MM-dd')
            if (value[0] === yesterdayDay) {
              return `昨天${new Date(yesterdayDay).Format('MM.dd')}`
            }

            let format = new Date(value[0]).Format('yyyy') === new Date().Format('yyyy') ? 'MM.dd' : 'yyyy.MM.dd'
            return `${new Date(value[0]).Format(format)}`
          } else {
            return `${new Date(value[0]).Format('yyyy.MM.dd')} - ${new Date(value[1]).Format('yyyy.MM.dd')}`
          }
        }
        return ''
      },
      doctorTypeFilter (value) {
        const doctorTypeMap = {
          1: '医生',
          2: '理疗师'
        }
        return doctorTypeMap[value] || ''
      }
    },
    props: {
      doctorId: {
        type: [Number, String],
        default: ''
      },
      teamList: {
        type: Array,
        default: () => []
      }
    },
    data () {
      return {
        loading: false,
        reqNum: 0,
        teamId: '',
        date: [new Date().Format('yyyy-MM-dd'), new Date().Format('yyyy-MM-dd')],
        summaryMap: {
          registerCount: 0,
          registerAmount: 0,
          orderCount: 0,
          orderAmount: 0,
          physioOrderCount: 0,
          physioOrderAmount: 0,
          physioExecuteCount: 0,
          physioExecuteAmount: 0,
          allotPhysioExecuteCount: 0,
          allotPhysioExecuteAmount: 0
        },
        memberMap: {
          list: []
        }
      }
    },
    created () {
      if (this.teamList.length > 0) {
        this.teamId = this.teamList[0].id
      }
      this.getStatistics()
      this.getMemberList()
    },
    methods: {
      afterRes () {
        this.reqNum--;
        if (this.reqNum <= 0) {
          this.loading = false
          this.reqNum = 0;
        }
      },
      teamChange () {
        this.memberMap.list = []

        this.getStatistics()
        this.getMemberList()
      },
      dateChange () {
        this.memberMap.list = []

        this.getStatistics()
        this.getMemberList()
      },
      memberTabelHeaderCell ({ columnIndex }) {
        if (columnIndex < 5) {
          return 'member_outpatient'
        } else {
          return 'member_physio'
        }
      },
      async getStatistics () {
        this.loading = true
        this.reqNum++
        const res = await getStudioStatistics({
          deptId: sessionStorage.getItem('deptId'),
          doctorId: this.doctorId,
          startDate: this.date[0],
          endDate: this.date[1],
          teamId: this.teamId
        })
        this.afterRes()
        if (res.code === 200) {
          this.summaryMap.registerCount = res.data.registerCount || 0
          this.summaryMap.registerAmount = res.data.registerAmount || 0
          this.summaryMap.orderCount = res.data.orderCount || 0
          this.summaryMap.orderAmount = res.data.orderAmount || 0
          this.summaryMap.physioOrderCount = res.data.physioOrderCount || 0
          this.summaryMap.physioOrderAmount = res.data.physioOrderAmount || 0
          this.summaryMap.physioExecuteCount = res.data.physioExecuteCount || 0
          this.summaryMap.physioExecuteAmount = res.data.physioExecuteAmount || 0
          this.summaryMap.allotPhysioExecuteCount = res.data.allotPhysioExecuteCount || 0
          this.summaryMap.allotPhysioExecuteAmount = res.data.allotPhysioExecuteAmount || 0
        }
      },
      async getMemberList () {
        this.loading = true
        this.reqNum++
        const res = await getStudioMember({
          deptId: sessionStorage.getItem('deptId'),
          doctorId: this.doctorId,
          startDate: this.date[0],
          endDate: this.date[1],
          teamId: this.teamId
        })
        this.afterRes()
        if (res.code === 200) {
          this.memberMap.list = res.data
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .studioData {
    width: 100%;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .header_left_radio /deep/ .el-radio-button__inner {
    padding: 0 28px;
    height: 36px;
    line-height: 34px;
  }

  .card {
    box-sizing: border-box;
    padding: 24px;
    width: 100%;
    background-color: #FFFFFF;
    border: 1px solid #E0E0E0;
    border-radius: 12px;
  }

  .card_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .card_header_left {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .card_header_icon {
    width: 26px;
    height: 26px;
  }

  .card_header_title {
    line-height: 28px;
    font-weight: bold;
    font-size: 18px;
    color: #000000;
  }

  .card_header_icon+.card_header_title {
    margin: 0 0 0 10px;
  }

  .card_header_date {
    margin: 0 0 0 8px;
    line-height: 22px;
    font-size: 14px;
    color: #667182;
  }

  .card_header_right {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .summary {
    margin: 24px 0 0 0;
  }

  .summary_list {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin: 16px 0 0 0;
    width: 100%;
  }

  .summary_item {
    box-sizing: border-box;
    padding: 24px;
    width: 616px;
    height: 138px;
    border-radius: 8px;
  }

  .summary_item.outpatient {
    background: linear-gradient( 142deg, #3D9AFE 0%, #1378FC 100%);
  }

  .summary_item.physio {
    background: linear-gradient( 142deg, #8E87FF 0%, #755EFF 100%);
  }

  .summary_item+.summary_item {
    margin: 0 0 0 16px;
  }

  .summary_title {
    line-height: 24px;
    font-weight: bold;
    font-size: 16px;
    color: #FFFFFF;
  }

  .summary_info {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    margin: 8px 0 0 0;
    width: 100%;
  }

  .summary_info_item {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }

  .summary_info_left {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .summary_info_right {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-end;
  }

  .summary_info_label {
    line-height: 22px;
    font-weight: 400;
    font-size: 14px;
    color: rgba(255,255,255,0.8);
  }

  .summary_info_value {
    margin: 2px 0 0 0;
    line-height: 36px;
    font-weight: bold;
    font-size: 26px;
    color: #FFFFFF;
  }

  .summary_info_line {
    margin: 34px 32px 0;
    width: 1px;
    height: 24px;
    background-color: #DBDEE2;
  }

  .member {
    margin: 24px 0 0 0;
    width: 100%;
  }

  .member_title {
    line-height: 28px;
    font-weight: bold;
    font-size: 18px;
    color: #000000;
  }

  .member_tabel_content {
    margin: 16px 0 0 0;
    width: 100%;
  }

  .member_table {
    border-radius: 8px;
  }

  .member_table /deep/ th.el-table__cell {
    padding: 9px 0;
  }

  .member_table /deep/ th.el-table__cell>.cell {
    line-height: 22px;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }

  .member_table /deep/ td.el-table__cell {
    padding: 8px 0;
  }

  .member_table /deep/ td.el-table__cell .cell {
    font-weight: bold;
    font-size: 16px;
    color: #000000;
  }

  .member_table /deep/ .member_outpatient {
    background-color: #E8F4FF;
  }

  .member_table /deep/ .member_physio {
    background-color: #EBEAFF;
  }

  .tabel_user {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
  }

  .tabel_user_portrait {
    flex-shrink: 0;
    width: 42px;
    height: 42px;
    border: 1px solid #E0E0E0;
    border-radius: 50%;
    overflow: hidden;
  }

  .tabel_user_portrait_img {
    width: 100%;
    height: 100%;
  }

  .tabel_user_info {
    flex-grow: 1;
    margin: 0 0 0 4px;
  }

  .tabel_user_name {
    line-height: 24px;
    font-weight: bold;
    font-size: 16px;
    color: #000000;
  }

  .tabel_user_type {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .tabel_user_type_tag {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    line-height: 22px;
    font-weight: 400;
    font-size: 14px;
    color: #667182;
  }

  .tabel_user_type_tag+.tabel_user_type_tag {
    margin: 0 0 0 6px;
  }

  .tabel_user_type_tag+.tabel_user_type_tag::before {
    content: '';
    display: block;
    margin: 0 6px 0 0;
    width: 1px;
    height: 14px;
    background-color: #667182;
  }
</style>